"use client";

import { useTranslations } from "next-intl";
import { type TransitionContentBlock } from "@/commonTypes/transitionContentBlocks";
import TransitionBlockRenderer from "./TransitionBlockRenderer";

export interface TransitionContentProps {
  questionTranslationKey: string;
  overlineTranslationKey?: string;
  contentBlocks: TransitionContentBlock[];
  theme?: string;
}

export default function TransitionContent({
  questionTranslationKey,
  overlineTranslationKey,
  contentBlocks,
  theme = "default",
}: TransitionContentProps) {
  const t = useTranslations();

  const titleText = t(questionTranslationKey);
  const overlineText = overlineTranslationKey ? t(overlineTranslationKey) : "";

  return (
    <article className="transition-content" data-theme={theme}>
      <div className="transition-content-body">
        {overlineText && <p className="transition-overline">{overlineText}</p>}

        <h1 className="transition-title">{titleText}</h1>

        {contentBlocks.map((block, index) => (
          <TransitionBlockRenderer key={index} block={block} />
        ))}
      </div>
    </article>
  );
}
